<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                      
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'enterprises.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i> 
                                            البيانات الأساسية</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                   <div class="row">
                                         <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.ar.name" placeholder="الاسم بالعربى">
                                         <div class="invalid-feedback" :style="getErrors['ar.name'] ? 'display: block' : 'display: none;'"   v-if="getErrors['ar.name']">
                                              {{ getErrors['ar.name'][0] }}
                                        </div>
                                    </div>
                                      </div>
                                   
                                    <div class="col-md-4">
                                            <label for="exampleFormControlInput1">العنوان</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>
                                       
                                        <input type="text" class="form-control" id="exampleFormControlInput1" v-model="data.form.ar.address" placeholder="العنوان">
                                         <div class="invalid-feedback" :style="getErrors['ar.address'] ? 'display: block' : 'display: none;'"   v-if="getErrors['ar.address']">
                                              {{ getErrors['ar.address'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                                                       <div class="col-md-4">
                                           <label for="exampleFormControlInput2">رقم الجوال 1</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                       
                                 
                                        <input type="text" class="form-control" id="exampleFormControlInput2" v-model="data.form.phone1" placeholder="رقم الهاتف 1">
                                         <div class="invalid-feedback" :style="getErrors['phone1'] ? 'display: block' : 'display: none;'"   v-if="getErrors['phone1']">
                                              {{ getErrors['phone1'][0] }}
                                        </div>
                                    </div>
                                     </div>
                                                                       <div class="col-md-4">
                                           <label for="exampleFormControlInput2">رقم الجوال 1</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                       
                                 
                                        <input type="text" class="form-control" id="exampleFormControlInput122" v-model="data.form.phone2" placeholder="رقم الهاتف 2">
                                         <div class="invalid-feedback" :style="getErrors['phone2'] ? 'display: block' : 'display: none;'"   v-if="getErrors['phone2']">
                                              {{ getErrors['phone2'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                  <div class="col-md-4">
                                              <label for="exampleFormControlInput13"> تاريخ بداية الاحتساب</label>
                                  <div class="">
                                      
                                      <date-picker v-model="data.form.start_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['start_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['start_date']">
                                                  {{ getErrors['start_date'][0] }}
                                            </div>
                                    </div>
                                      </div>

                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12"> ارسال اشعار  بعد عدد مرات غياب</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput122" v-model="data.form.notification_absent" placeholder="ارسال اشعار  بعد عدد مرات غياب">
                                         <div class="invalid-feedback" :style="getErrors['notification_absent'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_absent']">
                                              {{ getErrors['notification_absent'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12"> ارسال اشعار انذار نهائي غياب</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput222" v-model="data.form.notification_absent_repeat" placeholder="ارسال اشعار انذار نهائي غياب">
                                         <div class="invalid-feedback" :style="getErrors['notification_absent_repeat'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_absent_repeat']">
                                              {{ getErrors['notification_absent_repeat'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                      
                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12"> ايقاف الطالب بعد مرات عدد غياب</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput132" v-model="data.form.notification_student_stop" placeholder="ايقاف الطالب بعد مرات عدد غياب">
                                         <div class="invalid-feedback" :style="getErrors['notification_student_stop'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_student_stop']">
                                              {{ getErrors['notification_student_stop'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                      
                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12">رقم معرف القالب الخاص بإرسال اشعار  لوالى امر الطالب فى الحفظ والمراجعة</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput222" v-model="data.form.notification_save_review" placeholder="رقم معرف القالب الخاص بإرسال اشعار تحضير طالب">
                                         <div class="invalid-feedback" :style="getErrors['notification_save_review'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_save_review']">
                                              {{ getErrors['notification_save_review'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                      
                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12"> رقم معرف القالب الخاص بإرسال اشعار تحضير طالب</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput222" v-model="data.form.is_absence_temp" placeholder="رقم معرف القالب الخاص بإرسال اشعار تحضير طالب">
                                         <div class="invalid-feedback" :style="getErrors['is_absence_temp'] ? 'display: block' : 'display: none;'"   v-if="getErrors['is_absence_temp']">
                                              {{ getErrors['is_absence_temp'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                      
                                      <div class="col-md-4">
                                              <label for="exampleFormControlInput12"> رقم معرف القالب الخاص بإرسال اشعار قبول طالب</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput222" v-model="data.form.is_parent_accept" placeholder="رقم معرف القالب الخاص بإرسال اشعار قبول طالب">
                                         <div class="invalid-feedback" :style="getErrors['is_parent_accept'] ? 'display: block' : 'display: none;'"   v-if="getErrors['is_parent_accept']">
                                              {{ getErrors['is_parent_accept'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                    <div class="form-group col-md-6 mb-4">
                                        <label for="exampleFormControlInput3">الشعار</label>
                                        <input type="file" ref="file" class="form-control" id="exampleFormControlInput3" accept="image/*"  @change="uploadImage">
                                         <div class="invalid-feedback" :style="getErrors['image'] ? 'display: block' : 'display: none;'"   v-if="getErrors['image']">
                                              {{ getErrors['image'][0] }}
                                        </div>

                                    </div>
                                    <div class="form-group col-md-6 mb-4">
                                        <img v-if="data.form.image_path" :src="data.form.image_path" style="width:100px;height:100px" alt="الشعار">

                                    </div>


                                    <div class="form-group col-md-6 mb-4">
                                        <label for="exampleFormControlInput3">شعار الحلقة</label>
                                        <input type="file" ref="file" class="form-control" id="exampleFormControlInput4" accept="image/*"  @change="uploadImage2">
                                         <div class="invalid-feedback" :style="getErrors['second_image'] ? 'display: block' : 'display: none;'"   v-if="getErrors['second_image']">
                                              {{ getErrors['second_image'][0] }}
                                        </div>

                                    </div>
                                    <div class="form-group col-md-6 mb-4">
                                        <img v-if="data.form.second_image_path  " :src="data.form.second_image_path" style="width:100px;height:100px" alt="شعار الحلقة">

                                    </div>

                                     </div>
                                    
                                    <!-- <input type="submit" name="time" class="mt-4 mb-4 btn btn-button-7" value="حفظ"> -->
                                    <button type="submit" name="time" value="حفظ" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'dashboard'}">
                                      <span>رجوع</span>
                                    </router-link>

                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      data: {
        title: this.$root.trans['admins.edit'],
        subTitle: this.$root.trans['admins.edit.word'],
        checker: false,
        form:{
            ar: {name: '', address: ''},
            image: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.flashAlert();
      this.getRequirements();
  },
  methods: {
    resetForm(){
      this.data.form = {
            ar: {name: '', address: ''},
            image: '',
            image_path: '',
            second_image_path: ''
        };
    },
    uploadFile() {
        this.data.form.image = this.$refs.file.files[0];
      },

      getInfo(){
        this.$baseApi.get('/enterprises/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = this.dataHanlde(response.data.data.enterprise);
            
            }else if(response.data.code == 404){
                // router.push('/enterprises');
            }else{
                alert(response.data.data.error);
                // router.push('/enterprises');
            }
        });
      },
      update(){
          this.data.isRequested = true;

        this.$baseApi.patch('/enterprises/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
              this.sweetAlert(response.data.messages[0]);
              this.data.form = this.dataHanlde(response.data.data)
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
      getRoles(flag = false){
        if(flag){
          this.data.form.role_id = '';
        }
        
        this.$baseApi.get('/roles?pluck=1&role=' + this.data.form.role).then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.form.location_id = node.id;
      },
      dataHanlde(data){
        return {
          ar: {name: data.name, address: data.address},
          image_path: data.image_path,
          second_image_path: data.second_image_path,
          phone1: data.phone1,
          phone2  : data.phone2,
          start_date  : data.start_date,
          image: null,
          second_image: null,
          notification_student_stop: data.notification_student_stop,
          notification_absent_repeat: data.notification_absent_repeat,
          notification_absent: data.notification_absent,
          is_parent_accept: data.is_parent_accept,
          is_absence_temp: data.is_absence_temp,
          notification_save_review: data.notification_save_review,
        }
      },

      uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image = e.target.result;  
                };
      },
       uploadImage2(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.second_image = e.target.result;  
                };
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
